import React from 'react';

import { UserAvatar } from '@neptune/shared/avatars-ui';
import { bemBlock, Emblem } from '@neptune/shared/venus-ui';

import './UserEmblem.less';

type UserEmblemProps = {
  username: string;
  avatarUrl: string;
  onRemove: () => void;
};

const block = bemBlock('user-emblem');

export const UserEmblem = ({ username, avatarUrl, onRemove }: UserEmblemProps) => {
  return (
    <Emblem
      startDetail={<UserAvatar username={username} imageSrc={avatarUrl} size="xs" />}
      endDetail="cross"
      color="accent"
      className={block()}
      onEndDetailClick={onRemove}
      text={username}
    />
  );
};
